import {State} from '../model/state.model'

export const downloadPdf = (response: State<any>, fileName: string) => {

	const blob = new Blob([response.data], {type: 'application/pdf'})

	// const pdfUrl = window.URL.createObjectURL(blob) + '#view=FitW'
	// window.open(pdfUrl, fileName, '_blank')

	const url = window.URL.createObjectURL(blob)

	const link = document.createElement('a')
	link.href = url
	link.setAttribute('download',`${fileName}.pdf`,)

	// Append to html link element page
	document.body.appendChild(link)

	// Start download
	link.click()

	// Clean up and remove the link
	link?.parentNode?.removeChild(link)

}